export default __webpack_public_path__ + "static/media/UPIpmtPrev.d79869ce.jpeg";